export const FirebaseConfig = {
	apiKey: "AIzaSyADspQexWHf7b_NLcvdaq8BFEJI5z6YgqU",
	authDomain: "dauntless-theme-427501-b0.firebaseapp.com",
	databaseURL: "https://dauntless-theme-427501-b0-default-rtdb.firebaseio.com",
	projectId: "dauntless-theme-427501-b0",
	storageBucket: "dauntless-theme-427501-b0.appspot.com",
	messagingSenderId: "676085789280",
	appId: "1:676085789280:web:a5a5f127733471044a0905"
};